import { jsxs as y, jsx as s } from "react/jsx-runtime";
import { c as f } from "../../../index-Cu0xwYjD.js";
import { forwardRef as p } from "react";
import { Icon as i } from "../Icon/Icon.js";
import { s as t } from "../../../Button.module-C__9MZHi.js";
const N = p(
  ({
    variant: n = "surface",
    fullWidth: e = !1,
    iconLeft: a,
    iconRight: l,
    inverted: d = !1,
    children: c,
    className: I,
    size: o = "default",
    ...g
  }, h) => {
    const m = !!a, u = !!l, r = !c;
    return /* @__PURE__ */ y(
      "button",
      {
        ref: h,
        type: "button",
        className: f(
          t.button,
          t[n],
          t[o],
          {
            [t.fullWidth]: e,
            [t.inverted]: d,
            [t.iconOnly]: r,
            [t.hasIconLeft]: m && !r,
            [t.hasIconRight]: u && !r
          },
          I
        ),
        ...g,
        children: [
          m && /* @__PURE__ */ s(
            i,
            {
              name: a,
              className: f({
                [t.iconDefault]: o === "default",
                [t.iconLarge]: o === "large"
              })
            }
          ),
          c && /* @__PURE__ */ s("span", { children: c }),
          u && /* @__PURE__ */ s(
            i,
            {
              name: l,
              className: f({
                [t.iconDefault]: o === "default",
                [t.iconLarge]: o === "large"
              })
            }
          )
        ]
      }
    );
  }
), b = (n) => p((e, a) => /* @__PURE__ */ s(N, { variant: n, ref: a, ...e })), j = b("destructive");
export {
  N as Button,
  j as ButtonDestructive
};
